module.exports = __webpack_public_path__ + "img/矩形 2938.0722f8ec.png";